import { useState } from 'react';

import { Nullable } from 'chaika-common-types';

import { OptionType } from '@components/Select';

export function useReportTypesHandlers() {
    const [selectedReportTypes, setSelectedReportTypes] = useState<Nullable<OptionType<string>[]>>();

    function onSelectReportType(params: Nullable<OptionType<string>[]>): void {
        setSelectedReportTypes(params);
    }

    return {
        selectedReportTypes,
        onSelectReportType,
    };
}
